var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"cs-title mb-4",attrs:{"data-style":"2"}},[_c('h2',{staticClass:"content",attrs:{"data-title":_vm.currentRouteName}})])}
var staticRenderFns = []

export { render, staticRenderFns }